import { StoreResponse } from "./../interfaces/store-response";
import { MasterItem } from "./../interfaces/master-model";
import { CampaignConfig } from "./../interfaces/mechanic/ocr-model";
import { BaseModel } from "./../../home/share/interface/base";
import { CustomerAuthService } from "./../../login-phone/shared/services/auth.service";
import { map } from "rxjs/operators";
import { Config, chilPath } from "./../../config/config";
import { environment } from "./../../../environments/environment";
import { AppConsts } from "./../consts/app-consts";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { ApiService } from "./api.service";
import {
  UnileverUserInfo,
  RefreshResponse,
  RefreshRequest,
  LogoutRequest,
} from "./../interfaces/authUserInfo";
import { BehaviorSubject, Observable, config } from "rxjs";
import { Injectable } from "@angular/core";
import { MechanicConfig } from "../interfaces/mechanic/mechanic-list-model";

@Injectable({
  providedIn: "root",
})
export class StaffAuthService {
  private currentUserSubject: BehaviorSubject<UnileverUserInfo>;
  private campaignConfig: BehaviorSubject<CampaignConfig>;
  private mechanicListConfig: BehaviorSubject<MechanicConfig>;
  public currentUser: Observable<UnileverUserInfo>;
  constructor(
    private apiService: ApiService,
    public afAuth: AngularFireAuth,
    public router: Router,
    public customerService: CustomerAuthService
  ) {
    this.currentUserSubject = new BehaviorSubject<UnileverUserInfo>(
      JSON.parse(localStorage.getItem(AppConsts.currentCustomerKey))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.campaignConfig = new BehaviorSubject<CampaignConfig>(
      JSON.parse(localStorage.getItem(AppConsts.campaignConfig))
    );
    this.mechanicListConfig = new BehaviorSubject<MechanicConfig>(
      JSON.parse(localStorage.getItem(AppConsts.mechanicListConfig))
    );
  }
  public get currentUserValue(): UnileverUserInfo {
    return this.currentUserSubject.value;
  }

  public get currentCampaignConfig(): CampaignConfig {
    return this.campaignConfig.value;
  }

  public get currentMechnicListConfig(): MechanicConfig {
    return this.mechanicListConfig.value;
  }

  checkSignIn(userName: string, password: string) {
    const postData = {
      username: userName,
      password: password,
    };
    return this.apiService.post(
      Config.unileverApiPath.login,
      postData,
      environment.unileverApiHost
    );
  }

  setUserData(
    id: string,
    uid: string,
    fullname: string,
    password: string,
    token: string,
    refreshToken: string,
    transactionCode: string,
    role: string,
    userTypeId: number,
    userTypeName: string,
    qrLoginEnable: boolean,
    physScannerEnable,
    storeControlEnable: boolean,
    physCampaignId,
    skipPIIEnable: boolean
  ) {
    const tmpUser: UnileverUserInfo = {
      id: id,
      uid: uid,
      fullName: fullname,
      username: password,
      authToken: token,
      refreshToken: refreshToken,
      transactionCode: transactionCode,
      campaignId: 0,
      maxGiftPerUser: 4,
      role: role,
      mall: new MasterItem(),
      store: new MasterItem(),
      userTypeId: userTypeId,
      userTypeName: userTypeName,
      qrLoginEnable: qrLoginEnable,
      physScannerEnable: physScannerEnable,
      storeControlEnable: storeControlEnable,
      physCampaignId: physCampaignId,
      skipPIIEnable: skipPIIEnable,
    };
    localStorage.setItem(AppConsts.currentUserKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  refreshToken() {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentUserKey)
    );
    const refreshModel = new RefreshRequest();
    refreshModel.accessToken = tmpUser.authToken;
    refreshModel.refreshToken = tmpUser.refreshToken;
    return this.apiService.post<RefreshResponse>(
      Config.unileverApiPath.refresh,
      refreshModel,
      environment.unileverApiHost
    );
  }
  private updateUserData(tmpUser: UnileverUserInfo) {
    localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  updateToken(token) {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentCustomerKey)
    );
    if (token) {
      tmpUser.authToken = token;
      this.updateUserData(tmpUser);
    }
  }

  updateMall(mall: MasterItem) {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentUserKey)
    );
    tmpUser.mall = mall;
    this.updateUserData(tmpUser);
  }

  public updateStore(store: MasterItem): void {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentUserKey)
    );
    tmpUser.store = store;
    this.updateUserData(tmpUser);
  }

  updateCampaign(campaignId: number, maxGiftPerUser: number) {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentUserKey)
    );
    tmpUser.campaignId = campaignId;
    tmpUser.maxGiftPerUser = maxGiftPerUser;
    this.updateUserData(tmpUser);
  }

  signOut() {
    const tmpUser: UnileverUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentUserKey)
    );
    const logOutRequest = new LogoutRequest();
    logOutRequest.transactionCode = tmpUser.transactionCode;
    this.apiService
      .post(
        Config.unileverApiPath.logout,
        logOutRequest,
        environment.unileverApiHost
      )
      .subscribe((p) => { });
    //localStorage.removeItem(AppConsts.currentUserKey);
    //localStorage.removeItem(AppConsts.campaignConfig);
    localStorage.clear();
    this.customerService.logout();
  }

  public async getBaseConfig() {
    var res = await this.apiService
      .get<CampaignConfig>(
        Config.unileverApiPath.getCampaignConfig,
        environment.unileverApiHost
      )
      .toPromise();
    localStorage.setItem(AppConsts.campaignConfig, JSON.stringify(res));
    this.campaignConfig.next(res);
  }

  public async getMechanicListConfig() {
    var res = await this.apiService
      .get<MechanicConfig>(
        Config.unileverApiPath.getMechanicListConfig,
        environment.unileverApiHost
      )
      .toPromise();
    localStorage.setItem(AppConsts.mechanicListConfig, JSON.stringify(res));
    this.mechanicListConfig.next(res);
  }

  public checkStoreCode(storeCode: string) {
    var postData = {
      storeCode: storeCode,
    };
    return this.apiService.post<StoreResponse>(
      Config.unileverApiPath.checkStoreCode,
      postData,
      environment.unileverApiHost
    );
  }
}
